import { render, staticRenderFns } from "./luckyDrawList.vue?vue&type=template&id=3ca08b9e&scoped=true"
import script from "./luckyDrawList.vue?vue&type=script&lang=js"
export * from "./luckyDrawList.vue?vue&type=script&lang=js"
import style0 from "./luckyDrawList.vue?vue&type=style&index=0&id=3ca08b9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca08b9e",
  null
  
)

export default component.exports